import * as React from 'react';
import { Spawn } from 'oasis-os-contentful';
import './style.css';
import { useAuth } from 'oasis-auth';
import { isPlatform } from '@ionic/core';
import { useAppState } from 'oasis-os-react';

const Header: React.FC = () => {
  const [auth] = useAuth();
  const [, , app] = useAppState();
  const [mobileHeaderBar, setMobileHeaderBar] = React.useState(false);
  const authenticated = (auth.authenticated && !isPlatform('hybrid')) || isPlatform('hybrid');

  React.useEffect(() => {
    app.registerAction('showHeaderBarOnMobile', (show: boolean) => {
      setMobileHeaderBar(show ?? false);
    });
  });

  return (
    <>
      {authenticated && (
        <header
          data-testid="pwa-header"
          className={`pwa__header ${mobileHeaderBar ? '' : 'hide-header-on-mobile'}`}
        >
          <Spawn featuresField="header" />
        </header>
      )}
    </>
  );
};

export default Header;
